import { Link } from "react-router";

import { PageBreadcrumbs } from "@/shared/components/PageBreadcrumbs";
import { Goto } from "@/shared/navigation/Goto";

import { prefixSegments } from "./prefixPath";

interface ExplorerBreadcrumbsProps {
  bucketName: string;
  prefix: string;
}

/** The trail from the integrations list down to the folder currently open. */
export function ExplorerBreadcrumbs({
  bucketName,
  prefix,
}: ExplorerBreadcrumbsProps) {
  const segments = prefixSegments(prefix);

  return (
    <PageBreadcrumbs>
      <Link key="integrations" to={Goto.route.Settings.Integrations}>
        Integrations
      </Link>
      <Link key="s3" to={Goto.route.S3Integration}>
        AWS S3
      </Link>
      {segments.length === 0 ? (
        <span key="bucket">{bucketName}</span>
      ) : (
        <Link key="bucket" to={Goto.createS3BucketExplorerRoute(bucketName)}>
          {bucketName}
        </Link>
      )}
      {segments.map((segment, index) =>
        index === segments.length - 1 ? (
          <span key={segment.prefix}>{segment.label}</span>
        ) : (
          <Link
            key={segment.prefix}
            to={Goto.createS3BucketExplorerRoute(bucketName, segment.prefix)}
          >
            {segment.label}
          </Link>
        ),
      )}
    </PageBreadcrumbs>
  );
}
